import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { SituacaoContratoEnum } from 'src/app/shared/enums/situacao-contrato.enum';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';
import ContratoVendido from 'src/app/shared/models/contrato-vencido.model';
import { Contrato } from 'src/app/shared/models/contrato.model';
import { SituacaoContratoDataLayer } from 'src/app/shared/models/datalayer.model';
import PropostaOutroCanal from 'src/app/shared/models/proposta-outro-canal.model';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { ContratosApi } from '../../shared/api/contratos.api';
import { ContratoService } from '../contrato.service';
import { PropostasOutrosCanaisModalComponent } from '../propostas-outros-canais-modal/propostas-outros-canais-modal.component';
import { LoaderService } from './../../shared/loader/loader.service';

@Component({
  selector: 'app-contrato-page',
  templateUrl: './contrato-page.component.html',
  styleUrls: ['./contrato-page.component.scss']
})
export class ContratoPageComponent implements OnInit {

  contratos: Array<Contrato> = [];
  contratosVendidos: ContratoVendido[] = [];
  Bandeira = Bandeira;
  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 996px)');

  constructor(
    private loaderService: LoaderService,
    private contratosApi: ContratosApi,
    private contratoService: ContratoService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private currency: CurrencyPipe,
    private googleAnalyticsService: GoogleAnalyticsService,
    public autenticacaoService: AutenticacaoService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.getContratos();
    this.buscarContratosVendidos();

  }

  get temColaboradorAutenticado() {
    return this.autenticacaoService.temColaboradorAutenticado();
  }

  get bandeira() {
    return this.autenticacaoService.bandeira;
  }

  private async getContratos(): Promise<void> {
    try {
      this.loaderService.start();
      this.contratoService.iniciarFluxo();
      this.contratos = await this.contratoService.getContratos();
      this.enviarEventoGTM();
    } finally {
      this.loaderService.stop();
    }
  }

  selecionarContratoParaSegundaVia(contrato: Contrato): void {
    this.router.navigate([`portal/contratos/${contrato.contrato}/segundavia`]);
  }

  async selecionarContratoParaRenegocicao(contrato: Contrato): Promise<void> {
    this.router.navigate([`portal/contratos/${contrato.contrato}/renegociacao`]);
  }

  formatarData(data: string = ''): string {
    return data ? data.split('-').join('/') : '';
  }

  obterPlano(contrato: Contrato): string {
    if (contrato && contrato.parcelas && contrato.parcelas.length > 0) {
      return `${contrato.parcelas.length} x ${this.currency.transform(contrato.parcelas[0].valorTotalParcela, 'BRL')}`;
    }
    return '';
  }

  async buscarPropostasOutrosCanais(idContrato: string): Promise<PropostaOutroCanal[]> {
    try {
      this.loaderService.start();
      return this.contratoService.buscarPropostasOutrosCanais(idContrato);
    } finally {
      this.loaderService.stop();
    }
  }

  async exibirPropostasOutrosCanais(contrato: Contrato): Promise<void> {
    try {
      this.loaderService.start();
      const propostasOutrosCanais = await this.buscarPropostasOutrosCanais(contrato.contrato);
      const modalConfig: MatDialogConfig<any> = { data: propostasOutrosCanais };
      this.dialog.open(PropostasOutrosCanaisModalComponent, modalConfig).afterClosed();
    } finally {
      this.loaderService.stop();
    }
  }

  async buscarContratosVendidos(): Promise<void> {
    try {
      this.loaderService.start();
      this.contratosVendidos = await this.contratoService.buscarContratosVendidos();
    } finally {
      this.loaderService.stop();
    }
  }

  enviarEventoGTM() {
    const statusGeral = this.contratos?.some((contrato) =>
      contrato.situacao === SituacaoContratoEnum.SITUACAO_EM_ATRASO) ? SituacaoContratoDataLayer.EM_ATRASO : SituacaoContratoDataLayer.EM_ABERTO;

    this.googleAnalyticsService.pushEvent({
      event: 'update',
      pagina: {
        nomePagina: '/renegociacao/contratos',
        templatePagina: 'renegociacao',
        contratos: {
          statusGeral,
        }
      }
    });
  }

}
